import React from 'react'
import { ClerkProvider } from '@clerk/clerk-react'
import { useNavigate } from 'react-router-dom'
import { CLERK_PUBLISHABLE_KEY, DEMO_AUTH_ENABLED } from '@/lib/env'

export function ClerkProviderWithRouter({ children }: { children: React.ReactNode }) {
  const navigate = useNavigate()

  // Demo mode doesn't require Clerk.
  if (DEMO_AUTH_ENABLED) {
    return <>{children}</>
  }

  if (!CLERK_PUBLISHABLE_KEY) {
    return (
      <div className="min-h-screen flex items-center justify-center p-6">
        <div className="max-w-lg w-full bg-card text-card-foreground border rounded-xl p-6">
          <h1 className="text-lg font-semibold">Missing Clerk Configuration</h1>
          <p className="mt-2 text-sm text-muted-foreground">
            Set <code className="font-mono">VITE_CLERK_PUBLISHABLE_KEY</code> in Doppler for this environment.
          </p>
        </div>
      </div>
    )
  }

  return (
    <ClerkProvider
      publishableKey={CLERK_PUBLISHABLE_KEY}
      routerPush={(to) => navigate(to)}
      routerReplace={(to) => navigate(to, { replace: true })}
    >
      {children}
    </ClerkProvider>
  )
}

